// 文本绘制

function TextDrawer(canvas, context) {
    this.canvas = canvas;
    this.context = context;
}

// 尝试打断文本，分行
TextDrawer.prototype.breakText = function(text, fontSize) {
    text = text.trim(); // 删除两端的空格
    if (!text) return { height: 0, lines: [], widths: [] }; // 表示文本是空的
    const padding = 20; // 上下左右的边距，20像素
    const lineGapRatio = 0.1; // 行高是自适应的，自动设置为字体的十分之一
    const charGapRatio = 0.3; // 字符间距比值
    let maxWidth = this.canvas.width - padding - padding;
    //console.log('this.canvas.width', this.canvas.width, text, fontSize);
    let line = "";
    let currLine = "";
    let lines = [];
    this.context.font = fontSize + "px bold";
    this.context.textAlign = "left"; // 水平靠左
    this.context.textBaseline = "middle"; // 垂直居中
    let charGap = charGapRatio * fontSize;
    let widths = [];
    let textWidth = -charGap;
    let currTextWidth = 0;
    for (let i = 0, len = text.length; i < len; i++) {
        let char = text[i];
        if (text.charCodeAt(i) === 10) {
            // 换行符，直接换行
            if (line.length > 0) {
                // currLine = line + char;
                // currTextWidth = textWidth + this.context.measureText(char).width + charGap;
                lines.push(line);
                widths.push(textWidth);
            }
            textWidth = -charGap;
            line = "";
        } else {
            currLine = line + char;
            currTextWidth = textWidth + this.context.measureText(char).width + charGap;
            //console.log(line, textWidth, currTextWidth, maxWidth);
            if (currTextWidth > maxWidth) {
                lines.push(line);
                widths.push(textWidth);
                textWidth = -charGap;
                line = char;
            } else if (i + 1 === len) { // 最后一个字符了
                lines.push(currLine);
                widths.push(currTextWidth);
                break;
            } else {
                textWidth = currTextWidth;
                line = currLine;
            }
        }
        if (lines.length >= 2) break;
    }

    let h = 0;
    if (lines.length === 1) {
        h = fontSize + padding + padding;
    } else if (lines.length === 2) {
        h = fontSize + fontSize + lineGapRatio * fontSize + padding + padding;
    }

    return {
        lines,
        widths,
        height: h, // 下面需要增加的厚度
        fontSize,
    }
}

TextDrawer.prototype.drawText = function(textData, fontSize) {
    const shiftText = 0.10;
    const padding = 20; // 上下左右的边距，20像素
    const lineGapRatio = 0.1; // 行高是自适应的，自动设置为字体的十分之一
    const charGapRatio = 0.3; // 字符间距比值
    this.context.textAlign = "left"; // 水平靠左
    this.context.textBaseline = "middle"; // 垂直居中
    let charGap = charGapRatio * fontSize;
    let lineGap = lineGapRatio * fontSize;
    let top = this.canvas.height - textData.height;
    this.context.fillStyle = "white";
    // this.context.fillRect(0, top, this.canvas.width, textData.height);
    //console.log(fontSize, top, this.canvas.width, textData.height);
    let halfLineHeight = fontSize / 2;
    this.context.fillStyle = "#808080";
    this.context.font = fontSize + "px bold";
    //console.log('fontSize', fontSize, textData.lines.length);
    let shiftY = fontSize * shiftText;
    for (let i = 0, cnt = textData.lines.length; i < cnt; i++) {
        let line = textData.lines[i];
        let y = top + padding + (fontSize + lineGap) * i + halfLineHeight + shiftY;
        let left = (this.canvas.width - textData.widths[i]) * 0.5;
        for (let j = 0; j < line.length; j++) {
            let char = line[j];
            this.context.fillText(char, left, y);
            //console.log(char, left, y);
            let charWidth = this.context.measureText(char).width;
            left += charWidth + charGap;
        }
    }
}

export default TextDrawer;




// WEBPACK FOOTER //
// ./src/views/reliefBox/scripts/textDrawer.js